import { navigate as navigateGatsby } from "gatsby";
// Services
import intl from "./intl";

const navigate = (path, options) =>
  navigateGatsby(intl.localizePath(path), options);

export { navigate };
